import React, { useEffect, useState } from "react";
import DTOWarningARModal from "./DTOWarningARModal";
import WarningARModalPresenter from "./WarningARModalPresenter";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import {
  setAllClaimList,
  setAllClaimListLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimListSlice";
import { claimService } from "../../../../api/services/claimService";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  setAllClaimHistory,
  setClaimTicketLoader,
} from "../../../../infra/aggregates/myProfile/claimAggregates/claimHistorySlice";
import { setAllAirTicketHistory } from "../../../../infra/aggregates/myProfile/claimAggregates/airTicketHistorySlice";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  fullData?: any;
}

const WarningARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.authSlice);
  const { t } = useTranslation();

  const [allActions, setAllActions] = useState([]);
  const [historydata, setHistorydata] = useState([]);

  useEffect(() => {
    actionRequiredService
      .getWarningHistory(
        fullData.emp_id,
        fullData.department_id,
        fullData.company_id
      )
      .then((res) => {
        setHistorydata(res?.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const getClaimTypes = (data: any) => {
    setAllActions(data);
  };

  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOWarningARModal setAllActions={getClaimTypes} />

      <WarningARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allActions={allActions}
        trans={t}
        fullData={fullData}
        userId={selector.user_id}
        historydata={historydata}
        handleSubmitAR_Request={hitAction}
      />
    </div>
  );
};

export default WarningARModalController;
